import { useState } from 'react';
import { updateNewCreditDate } from 'services/orders';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useEditCommittedPaymentDateForOrder = () => {
  const [isLoading, setIsLoading] = useState(false);

  const editDate = async (id: number, date: string) => {
    setIsLoading(true);
    try {
      await updateNewCreditDate(id, date);

      displaySuccessNotification({ customJSXMessage: <>La fecha de compromiso se guardo correctamente</> });
      return true;
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };
  return { isLoading, editDate };
};
